import { daysSinceTimestamp } from '../../../../global/common/dateFormatting';

export const _allowGolfEventUpdates = {
  any: true,
  roundMatchOpenScoring: true,
  roundMatchActivate: true,
  roundMatchClear: true,
  roundResultsClear: true,
  roundMatchCreate: true,
  roundMatchUpdate: true,
  detailsUpdate: true,
  golferUpdate: true,
  tournamentMatches: true,
  tournamentResults: true,
  tournamentActive: true
}

export const rts = {
  handleAmmend_eventGolfers: 'handleAmmend_eventGolfers',
  handleAmmend_golfTournamentPreview: 'handleAmmend_golfTournamentPreview',
  handleSet_golfEventData: 'handleSet_golfEventData',
}

export const golfEventReducer = (state, action) => {

  const { type, golfData, viKey } = action

  switch (type) {
    case rts.handleSet_golfEventData:
      let _golfData = golfData
      switch (viKey) {
        case 'teams':
          if (golfData) {
            const teams = {}
            Object.keys(golfData).forEach((key, index) => {
              teams['team' + (index + 1)] = golfData[key]
              teams['team' + (index + 1)].key = key
            })
            _golfData = teams
          }
          break;

        case 'golfers': // allGolfers 
          if (_golfData) {
            Object.keys(_golfData).forEach((key, index) => {
              _golfData[key]._itemKey = key
              _golfData[key]._dateProps = {
                daysSinceUpdate: daysSinceTimestamp(_golfData[key]._updateDate)
              }
            })
          }
          break;
        default:
        // nothing
      }

      return {
        ...state,
        [viKey]: _golfData,
      }

    case rts.handleAmmend_eventGolfers:
      return { ...state, golfers_auth: action.golfers_auth }

    case rts.handleAmmend_golfTournamentPreview:
      const { golfTournaments } = state
      const { golfTournament } = action
      const docKey = 'preview'
      golfTournament._itemKey = docKey
      const _golfTournaments = golfTournaments ? golfTournaments : {}
      _golfTournaments[docKey] = golfTournament
      return { ...state, golfTournaments: _golfTournaments }

    default:
      return { ...state }
  }
}

export const golfEventHandlers = (dispatch) => {
  return {
    handleAmmend_eventGolfers: (golfers_auth) => { dispatch({ type: rts.handleAmmend_eventGolfers, dispatch, golfers_auth }) },
    handleAmmend_golfTournamentPreview: (golfTournament) => { dispatch({ type: rts.handleAmmend_golfTournamentPreview, dispatch, golfTournament }) },
    handleSet_golfEventData: (golfData, viKey) => { dispatch({ type: rts.handleSet_golfEventData, dispatch, golfData, viKey }) },
  }
}

export const golfEventInitialState = (init_state) => {
  return { ...init_state }
};


